import React from "react"; 
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <main className="about">
      <section className="about-hero"><div><p>THE BENTOMARKET STORY</p><h1>Useful design for calmer everyday routines.</h1></div></section>
      <section className="about-intro page-shell"><div><p className="about-dropcap">Bentomarket is a Hong Kong-based online store for practical everyday goods, operated by Hong Kong Zhichenda Trading Co., Limited.</p><p>We select kitchen, home, workspace and lifestyle essentials with an emphasis on useful details, approachable materials and easy care.</p><p>Every item is presented with clear information so you can choose confidently for your space and routine.</p><Link to="/shop" onClick={toTop}>Explore the collection →</Link></div><img src="/img/home/about.png" alt="Bentomarket product selection workspace" /></section>
      <section className="about-values"><div className="page-shell"><h2>Useful by design.<br />Chosen with care.</h2><div className="about-values-grid"><article><span>01</span><h3>Practical</h3><p>Every product is selected for a clear everyday purpose.</p></article><article><span>02</span><h3>Considered</h3><p>We value durable materials, simple care and thoughtful details.</p></article><article><span>03</span><h3>Clear</h3><p>Accurate descriptions and responsive support help you shop confidently.</p></article></div></div></section>
    </main>
  );
}

export default About;
